<template>
    <footer class="flex items-center justify-center space-x-1 p-4 text-sm text-gray-700">
        <AppFooterLink href="https://github.com/noeldemartin/ramen#what-is-this">
            {{ $t('footer.help') }}
        </AppFooterLink>
    </footer>
</template>
